import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": /*@__PURE__*/_normalizeClass(['message-abstract-video'])
};
var _hoisted_2 = {
  "class": "message-abstract-video-box"
};
var _hoisted_3 = ["src"];
import Icon from "../../../../common/Icon.vue";
import playIcon from "../../../../../assets/icon/video-play.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-abstract-video',
  props: {
    messageContent: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: __props.messageContent.snapshotUrl,
        "class": _normalizeClass(['messageVideo'])
      }, null, 8, _hoisted_3), _createVNode(Icon, {
        file: _unref(playIcon),
        "class": "video-play"
      }, null, 8, ["file"])])]);
    };
  }
});